/* eslint-disable camelcase */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */

import _ from 'underscore';
import $ from 'jquery';
import { withUiBlock } from '@bingads-webui/uiblocker';
import jsdata from '@bingads-webui-campaign-legacy/hotel-center-js-data/index';
import edm from '@bingads-webui-campaign-legacy/hotel-center-edm/index';
import { CampaignAdgroupSelectorView } from '@bingads-webui-campaign-react/campaign-adgroup-selector';
import { CampaignSelectorView } from '@bingads-webui-campaign-react/campaign-selector';

export const CAMPAIGN_PAGESIZE = 10;
export const ADGROUP_PAGESIZE = 6;

function transformCampaignData(data) {
  if (!data || !_.isArray(data)) {
    return [];
  }

  const campaignData = data.map(item => ({
    Id: item.Id,
    name: item.Name,
    status: item.Status,
  }));

  return {
    totalCount: data.totalCount,
    items: campaignData,
  };
}

function transformAdgroupData(data) {
  if (!data || !_.isArray(data)) {
    return [];
  }

  const adgroupData = data.map(item => ({
    Id: item.Id,
    name: item.Name,
    status: item.Status,
    campaignId: item.SubAccountId,
    campaignName: item.SubAccountName,
  }));

  return {
    totalCount: data.totalCount,
    items: adgroupData,
  };
}

const fecthCampaignData = ({ query = '', pageNumber = 0, pageSize = CAMPAIGN_PAGESIZE }, isSubaccountSelector = true) => {
  const jsDataOptions = {
    cacheResponse: false,
  };

  const queryOption = {
    offset: pageNumber * pageSize,
    limit: pageSize,
    where: { Name: { $contains: query }, Status: { $eq: 'Active' } },
  };

  const uiBlockContainer = isSubaccountSelector ? $('.ba-campaign-selector .dropdown-menu') :
    $('.ba-campaign-adgroup-selector .dropdown-menu');

  return jsdata.SubAccount.findAll(queryOption, jsDataOptions)
    .then(data => transformCampaignData(data)).finally(withUiBlock(uiBlockContainer));
};

const fecthAdgroupData = ({
  query = '',
  pageNumber = 0,
  pageSize = ADGROUP_PAGESIZE,
  scopeParentItem,
}) => {
  const jsDataOptions = {
    cacheResponse: false,
  };

  const queryOption = {
    offset: pageNumber * pageSize,
    limit: pageSize,
    where: { Name: { $contains: query } },
  };

  const uiBlockContainer = $('.ba-campaign-adgroup-selector .dropdown-menu');

  if (scopeParentItem) {
    jsDataOptions.entitySet = edm.currentAccount.SubAccounts.$withKey(scopeParentItem.Id).HotelGroups;
  }
  return jsdata.HotelGroup.findAll(queryOption, jsDataOptions)
    .then(data => transformAdgroupData(data)).finally(withUiBlock(uiBlockContainer));
};

const campaignSelectorStringKeys = {
  emptyListContent: 'CampaignSelector_EmptyList_Content',
  listHeader: 'SubaccountHotelSelector_List_Subaccount_Header',
  selectEntities: 'AdExtensions_MultiSelect_Select_Subaccounts',
  actionBar: 'CampaignSelector_Result_Action_Bar',
  resultHeader: 'SubaccountSelector_Result_List_Header',
};

const campaignAdgroupSelectorStringKeys = {
  emptyListContent: 'CampaignSelector_EmptyList_Content', // No results to display.
  campaignListHeader: 'SubaccountHotelSelector_List_Subaccount_Header', // Subaccounts: {{itemCount}}
  adgroupListHeader: 'SubaccountHotelSelector_List_Hotel_Header', // Available hotel groups: {{itemCount}}
  campaignEntities: 'AdgroupSelector_EntityType_Subaccounts',
  adgroupEntities: 'AdgroupSelector_EntityType_Hotelgroups',
  selectEntities: 'AdExtensions_MultiSelect_Select_Hotelgroups', // Select hotel group(s)
  actionBar: 'CampaignSelector_Result_Action_Bar', // Select all on this page
  resultHeader: 'SubaccountHotelSelector_Result_List_Header', // Selected hotel groups: {{itemCount}}
};

const createCampaignView = ({ ko_model, i18n }) => new CampaignSelectorView({
  fetch: args => fecthCampaignData(args, true),
  stringKeys: campaignSelectorStringKeys,
  isMultiMode: true,
  onSelectDone: values => ko_model.selectedCampaigns(values),
  i18n,
});

const createCampaignAdgroupView = ({ ko_model, i18n }) => new CampaignAdgroupSelectorView({
  campaign: {
    pageSize: CAMPAIGN_PAGESIZE,
    onFetch: args => fecthCampaignData(args, false),
  },
  adgroup: {
    pageSize: ADGROUP_PAGESIZE,
    onFetch: args => fecthAdgroupData(args),
  },
  onSelectDone: values => ko_model.selectedAdgroups(values),
  isMultiMode: true,
  stringKeys: campaignAdgroupSelectorStringKeys,
  i18n,
});

export default {
  fecthCampaignData,
  fecthAdgroupData,
  createCampaignView,
  createCampaignAdgroupView,
  campaignSelectorStringKeys,
  campaignAdgroupSelectorStringKeys,
  CAMPAIGN_PAGESIZE,
  ADGROUP_PAGESIZE,
};
